<template>
    <div>
        <ContactModal
            ref="contactModal"
            :expected-domain="expectedContactDomain"
            :remove-action-visible="removeActionVisible"
            :actions-visible="actionsVisible"
            @save="onSave"
        />
        <HamletTable
            :columns="columns"
            :fetch="fetch"
            @created="onTableCreated"
            @onRowClick="edit"
        >
            <template #header-label>
                {{ $t('Component(Contacts):grid-label') }}
            </template>

            <template #header-controls>
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mt-0 btn-icon"
                    @click="add"
                >
                    <feather-icon icon="PlusIcon" />
                </b-button>
            </template>
            <template #cell-email="data">
                {{ extractEmail(data.item) }}
            </template>

            <template #cell-actions="data">
                <div class="text-right">
                    <Button
                        variant="primary"
                        :class="{'btn-icon': true, 'mr-1': removeActionVisible}"
                    >
                        <feather-icon icon="EditIcon" />
                    </Button>
                    <b-button
                        v-if="removeActionVisible"
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="danger"
                        class="btn-icon"
                        @click.prevent.stop="remove(data.item)"
                    >
                        <feather-icon icon="Trash2Icon" />
                    </b-button>
                </div>
            </template>
        </HamletTable>
    </div>
</template>

<script>
import {BButton} from 'bootstrap-vue'
import HamletTable from "@core/components/common/HamletTable";
import {ContactModal} from "@core/components/supply-chain";
import Ripple from 'vue-ripple-directive'
import {Button} from "@core/components/common";

export default {
    directives: {Ripple},
    components: {
        HamletTable, Button,
        ContactModal,
        BButton
    },
    props: {
        selected: {
            type: Array,
            default() {
                return [];
            }
        },
        expectedContactDomain: {
            default: null
        },
        actionsVisible: {
            default: true
        },
        removeActionVisible: {
            default: true
        }
    },
    data() {
        const columns = [
            {
                key: 'name',
                label: this.$t('Component(Grid):column-name')
            },
            {
                key: 'position',
                label: this.$t('Component(Grid):column-position')
            },
            {
                key: 'email',
                label: this.$t('Component(Grid):column-email')
            },
        ];

        if (this.actionsVisible) {
            columns.push(
                {
                    key: 'actions',
                    label: this.$t('Component(Grid):column-actions'),
                    class: 'text-right'
                }
            );
        }

        return {
            columns: columns,
            table: {
                config: null,
                cb: null
            }
        }
    },
    methods: {
        extractEmail(organization) {
            if (organization.communicationChannels.length > 0) {
                return organization.communicationChannels
                    .filter(ch => ch.type === 'email')
                    .map(ch => ch.channel)
                    .join(', ');
            }

            return '';
        },
        onTableCreated(config, cb) {
            this.table.config = config;
            this.table.cb = cb;
        },
        onSave(id, contact) {
            this.$emit('save', id, contact);
        },
        remove(contact) {
            this.$emit('remove', contact);
        },
        add() {
            this.$refs.contactModal.blank();
            this.$refs.contactModal.show();
        },
        edit(contact) {
            this.$refs.contactModal.populate(contact.id, contact);
            this.$refs.contactModal.show();
        },
        fetch(config, cb) {
            const start = (config.page - 1) * config.perPage;
            cb(
                this.selected.length,
                this.selected.slice(start, start + config.perPage)
            );
        }
    },
    watch: {
        selected(v) {
            this.fetch(this.table.config, this.table.cb);
        }
    }
}
</script>

<style scoped>

</style>
